<ion-header>
	<ion-toolbar>
		<ion-title>{{ 'APP_UPDATE_TITLE' | translate }}</ion-title>

		<!-- <ion-buttons slot="end" *ngIf="CurrentStatus?.Id == Status?.UpdateNotAvailable.Id || CurrentStatus?.Id == AllStatus?.Error.Id"> -->

		<ion-buttons slot="end">
			<ion-button style="margin: 0 16px;" 
						fill="clear" 
						shape="round" 
						color="danger" 
						[hidden]="CurrentStatus?.Id == AllStatus?.DownloadComplete.Id
							   || CurrentStatus?.Id == AllStatus?.DownloadingUpdate.Id
							   || CurrentStatus?.Id == AllStatus?.SearchingUpdate.Id
							   || CurrentStatus?.Id == AllStatus?.UpdateAvailable.Id"
						(click)="OnClose($event)">
				{{ 'CANCEL' | translate }}
			</ion-button>
		</ion-buttons>

	</ion-toolbar>
</ion-header>

<ion-content customScrollbar>

	<ion-grid>

		<!-- <ion-row class="ion-padding">
			<ion-col size="12" class="status-title">
				<b>{{ 'APP_CURRENT_VERSION' | translate }}</b>
			</ion-col>
			<ion-col size="12" class="status-message">	
				<em>{{ AppVersion }}</em>
			</ion-col>
		</ion-row> -->

		<ion-row class="ion-padding">
			<ion-col size="12" class="status-title">
				<b>{{ 'APP_STATUS_UPDATE' | translate }}</b>
			</ion-col>
			<ion-col size="12" class="status-message">	
				<ion-spinner name="crescent" *ngIf="CurrentStatus?.Id == AllStatus?.SearchingUpdate.Id"></ion-spinner> 
				<em>{{ CurrentStatus?.Value | translate }}</em>
			</ion-col>
		</ion-row>

		<ion-row class="ion-padding-horizontal">

			<ion-col [ngSwitch]="CurrentStatus?.Id">

				<ion-progress-bar *ngSwitchCase="AllStatus?.SearchingUpdate?.Id"
								  type="indeterminate" 
								  color="tertiary">
				</ion-progress-bar>

				<ion-progress-bar *ngSwitchCase="AllStatus?.DownloadingUpdate?.Id"
								  type="indeterminate" 
								  color="tertiary">
				</ion-progress-bar>

				<ion-progress-bar *ngSwitchCase="AllStatus?.DownloadComplete?.Id"
								  type="determinate"
								  value="1"
								  color="success">
				</ion-progress-bar>

			</ion-col>

		</ion-row>

		<ion-row class="ion-padding" *ngIf="MetadataNewUpdate">
			<ion-col size="12" class="status-title">
				<b>{{ 'APP_UPDATE_CHANGELOG' | translate }}</b>
			</ion-col>
			<ion-col size="12" class="status-message">	
				<div [innerHTML]="MetadataNewUpdate.readme"></div>
				<em>V. {{ MetadataNewUpdate.version }}</em>
			</ion-col>
		</ion-row>

	</ion-grid>

</ion-content>

<ion-footer *ngIf="CurrentStatus?.Id == AllStatus?.UpdateAvailable?.Id 
				|| CurrentStatus?.Id == AllStatus?.DownloadingUpdate?.Id
				|| CurrentStatus?.Id == AllStatus?.DownloadComplete?.Id">
	<ion-toolbar>
		<ion-buttons class="align-center-horizontal">
			<ion-button shape="round" 
						fill="solid" 
						[disabled] = "CurrentStatus?.Id != AllStatus?.UpdateAvailable?.Id"
						(click)="OnDownloadUpdateAndRestart($event)">
				{{ 'APP_UPDATE_DOWNLOAD_AND_UPDATE' | translate }}
			</ion-button>

			<!-- <ion-button *ngSwitchCase="AllStatus?.DownloadComplete?.Id"
						shape="round" 
						fill="solid" 
						(click)="OnDownloadUpdate($event)">
				{{ 'APP_UPDATE_AND_RESTART' | translate }}
			</ion-button> -->
		</ion-buttons>
	</ion-toolbar>

</ion-footer>

